export const uiMap = {
  rating: 'Rating',
  name: 'Name',
  date: 'Date',
  shuffle: 'Shuffle',
};

export const sortMap = {
  Rating: 'rating',
  Name: 'name',
  Date: 'createdAt',
};

export const apiUrl = process.env.REACT_APP_API_URL || '';




// WEBPACK FOOTER //
// ./src/constants.js